import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Logout() {
  const location = useLocation();
  useEffect(() => {
    localStorage.removeItem('username');
    localStorage.removeItem('password');
    const queryParams = new URLSearchParams(location.search);
    const website = queryParams.get('website');
    let redirectUrl = `https://www.uficon.com/`;
    if(website == 'education'){
      redirectUrl = `https://education.uficon.com/`;
    }else if(website == 'pre-order'){
      redirectUrl = `https://pre-order-service.uficon.com/`;
    }
    window.location.href = redirectUrl;

  }, []);


  return (
    <div className="App">
      <header className="App-header">
       
      </header>
    </div>
  );
}

export default Logout;
